import React, { useEffect, useState } from "react";
import "../../../assets/scss/subscription.scss";
import "flatpickr/dist/flatpickr.css";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-daterangepicker/daterangepicker.css";
import Spinner from "../../../@core/components/spinner/Fallback-spinner";
import Repository from "../../../configs/axios/repository";
import selected from "../../../assets/images/pages/selected.png";
import { useHistory } from "react-router-dom";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import CheckoutForm from "./checkoutForm";
import { Formik, Form, Field, ErrorMessage } from "formik";
import errorCodePng from "../../../assets/images/errorCode.png";
import correctCupon from "../../../assets/images/correctCupon.png";

const Subscription = (props) => {
    const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUB_KEY);
    const [loadingData, setLoadingData] = useState(true);
    const [products, setProducts] = useState([]);
    const [promoCode, setPromoCode] = useState("");
    const history = useHistory();
    const [showForm, setShowForm] = useState(false);
    const [showError, setShowError] = useState(false);
    const [correctCode, setCorrectCode] = useState(false);
    const [cuponInputClasname, setCuponInputClasname] = useState("couponInput");
    const [showCuponError, setShowCuponError] = useState(false);
    const [showCuponRemove, setShowCuponRemove] = useState(false);
    const [freeTrial, setFreeTrial] = useState("7");
    const [trialDaysCount, setTrialDaysCount] = useState(
        Number(process.env.REACT_APP_FREE_TRIAL_PERIOD)
    );
    const [warning, setWarning] = useState(null);
    const [subscriptionError, setSubscriptionError] = useState(null);
    const [priceId, setPriceId] = useState(null);
    const [productId, setProductId] = useState(null);
    const currentURL = new URL(window.location.href);
    const [couponId, setCouponId] = useState(null);
    const [showPromoCode, setShowPromoCode] = useState(true);
    const [couponCodeValue, setCouponCodeValue] = useState(null);
    useEffect(() => {
        if (
            currentURL.pathname === "/subscription" &&
            currentURL.searchParams.has("promoCode")
        ) {
            const promoCodeValue = currentURL.searchParams.get("promoCode");
            if (promoCodeValue) {
                setCouponCodeValue(promoCodeValue);
            } else {
                console.log("yes, promoCode is present but has no value");
            }
        }
    }, []);
    const useCoupon = async (values) => {
        const result = await Repository.findByEndPoint(
            `api/couponCode/findCouponCodeByUserId/${values.code}`
        );

        if (result.data.data != null) {
            if (result.data.data.is_used) {
                setCuponInputClasname("couponInput couponInputErr");

                setShowCuponError(true);
                setCorrectCode(false);
            } else {
                setShowCuponError(false);
                setCorrectCode(true);
                setShowCuponRemove(false);
                setCouponId(result.data.data.id);
                setTrialDaysCount(result.data.data.days_count);
                setFreeTrial(result.data.data.days_count);
                setCuponInputClasname("couponInput couponInputCorrect");
            }
        } else {
            setCuponInputClasname("couponInput couponInputErr");
            setCorrectCode(false);
            setShowCuponError(true);
        }
    };
    const getProducts = async () => {
        setLoadingData(false);

        const resultUser = await Repository.findByEndPoint(
            `api/users/findThisUser`
        );
        if (resultUser.data?.success === true) {
            if (resultUser.data.data.promo_code_used == true) {
                setShowPromoCode(false);
            }
            if(resultUser.data.data.stripe_subscription_id){
                if(resultUser.data.data.stripe_subscription_type=="past_due"){
                    setSubscriptionError("past_due")
                }
            }
        }
        const result = await Repository.findByEndPoint(
            `api/stripe/getProductsWithPrices`
        );

        if (result.data?.success) {
   
            setProducts(
                result.data.data.data
                    .map((product) => {
                        // Check if the product is active
                        if (product.active === true) {
                            return {
                                ...product,
                                prices: product.prices.filter(
                                    (price) => price.active
                                ),
                            };
                        } else {
                            return null; // Return null for inactive products
                        }
                    })
                    .filter(Boolean) // Filter out null values
            );
        }
        setLoadingData(true);
    };

    useEffect(() => {
        getProducts();
    }, []);

    return loadingData ? (
        <div className="subscriibtionBodyDiv ">
            <div className="sectionSubParentDiv ">
                <div className=" subLeftContent">
                    <div
                        className={
                            products[1]?.prices[0]?.id == priceId
                                ? "subscriptions selectedItemsPay"
                                : "subscriptions  "
                        }
                        onClick={() => {
                            setPriceId(products[1]?.prices[0]?.id);
                            setProductId(products[1]?.id);
                        }}
                    >
                        <h1>
                            Monthly Subscription - $
                            {products[1]?.prices[0]?.unit_amount / 100}
                        </h1>
                        <p>
                            Gain unlimited access written exams, and multiple
                            choice tests, a real-time feedback system plus all
                            additional Smart Study features!
                        </p>
                        {priceId == products[1]?.prices[0]?.id ? (
                            <div className="selectedPaymnt">
                                <img src={selected} alt="selected" />
                            </div>
                        ) : (
                            ""
                        )}
                    </div>
                    <div
                        className={
                            products[1]?.prices[1]?.id == priceId
                                ? "subscriptions mt-5 selectedItemsPay"
                                : "subscriptions mt-5 "
                        }
                        onClick={() => {
                            setPriceId(products[1]?.prices[1]?.id);
                            setProductId(products[1]?.id);
                        }}
                    >
                        <h1>
                            Yearly Subscription - $
                            {products[1]?.prices[1]?.unit_amount / 100}
                        </h1>
                        <p>
                            Save money by accessing Smart Study premium for an
                            entire year!
                        </p>
                        {products[1]?.prices[1]?.id == priceId ? (
                            <div className="selectedPaymntYerly">
                                <img src={selected} alt="selected" />
                            </div>
                        ) : (
                            ""
                        )}
                    </div>
                    <p className={showError ? "showErr" : "showErrNone"}>
                        Please select payment method.
                    </p>
                </div>
                <div className="subscriptionTitle ">
                    <div className="sectionParentDiv subRightContent">
                        <div className="mt-4">
                            <div className="subSection">
                                <span>Start {freeTrial} Day Free Trial</span>
                                <p>
                                    Try Smart Study Premium for {freeTrial} Days
                                    before you get billed.
                                </p>
                            </div>
                            <div className="lineSub"></div>
                            <div className="personalData">
                                <span>Your personal data</span>
                            </div>
                            <div className="mt-3">
                                {showPromoCode ? (
                                    <div className="couponCode">
                                        <Formik
                                            initialValues={{
                                                code: couponCodeValue,
                                            }}
                                            validate={(values) => {
                                                const errors = {};
                                                setCouponCodeValue(values.code);
                                                setShowCuponRemove(false);
                                                setTrialDaysCount(null);
                                                setCorrectCode(false);
                                                setShowCuponError(false);
                                                setCuponInputClasname(
                                                    "couponInput"
                                                );

                                                return errors;
                                            }}
                                            onSubmit={(values) => {
                                                useCoupon(values);
                                            }}
                                        >
                                            {({ isSubmitting }) => (
                                                <Form className="formikCupon mt-1">
                                                    <div className="form-name promoCode d-flex">
                                                        <Field
                                                            value={
                                                                couponCodeValue
                                                                    ? couponCodeValue
                                                                    : ""
                                                            }
                                                            className={
                                                                cuponInputClasname
                                                            }
                                                            type="text"
                                                            name="code"
                                                            placeholder="Enter your promo code"
                                                            maxLength={10}
                                                        />
                                                        {showCuponError ? (
                                                            <div className="couponCodePng">
                                                                <img
                                                                    src={
                                                                        errorCodePng
                                                                    }
                                                                    alt="errorCodePng"
                                                                />
                                                            </div>
                                                        ) : (
                                                            ""
                                                        )}
                                                        {correctCode ? (
                                                            <div className="couponCodePng">
                                                                <img
                                                                    src={
                                                                        correctCupon
                                                                    }
                                                                    alt="errorCodePng"
                                                                />
                                                            </div>
                                                        ) : (
                                                            ""
                                                        )}

                                                        <div className="couponBtnDiv">
                                                            <button
                                                                type="submit"
                                                                className="btnCoupon"
                                                            >
                                                                Apply
                                                            </button>
                                                        </div>
                                                    </div>
                                                    <ErrorMessage
                                                        className="errorMessags"
                                                        name="code"
                                                        component="div"
                                                    />
                                                </Form>
                                            )}
                                        </Formik>
                                        <div className="showCuponError mt-2">
                                            {showCuponError
                                                ? "Promo Code cannot be added to your cart!"
                                                : ""}
                                        </div>

                                        <div className="showCuponError mt-2">
                                            {showCuponRemove
                                                ? "Please remove incorrect code."
                                                : ""}
                                        </div>
                                        <div className="showCupon mt-2">
                                            {trialDaysCount != null &&
                                            correctCode ? (
                                                <span>
                                                    <span className="correctMsgCuponCode">
                                                        Your discount (
                                                        {trialDaysCount} days)
                                                        has been applied.
                                                    </span>
                                                    &nbsp;
                                                    <span
                                                        className="removeCuponCode"
                                                        onClick={() => {
                                                            setTrialDaysCount(
                                                                null
                                                            );
                                                            setShowCuponError(
                                                                false
                                                            );
                                                            setCorrectCode(
                                                                false
                                                            );
                                                            setCouponCodeValue(
                                                                ""
                                                            );
                                                        }}
                                                    >
                                                        Remove
                                                    </span>
                                                </span>
                                            ) : (
                                                ""
                                            )}
                                        </div>
                                    </div>
                                ) : (
                                    ""
                                )}

                                <Elements stripe={stripePromise}>
                                    <CheckoutForm
                                        setShowForm={setShowForm}
                                        productId={productId}
                                        priceId={priceId}
                                        setLoadingData={setLoadingData}
                                        setShowError={setShowError}
                                        trialDaysCount={trialDaysCount}
                                        couponId={couponId}
                                        setWarning={setWarning}
                                        warning={warning}
                                    />
                                </Elements>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    ) : (
        <Spinner spiner={true} />
    );
};

export default Subscription;
